const it = {
  "front.faq.chat.title": "FAI UNA DOMANDA",
  "front.faq.chat.description": "supporto immediato per gli ospiti del ristorante",
  "front.faq.chat.welcome": "Qui puoi fare una domanda direttamente.",
  "front.faq.chat.placeholder": "messaggio",
  "front.faq.chat.send": "invia",
  "front.faq.chat.unsupportedLanguage": "Spiacenti, questa chat attualmente supporta solo inglese e tedesco.",
  "front.faq.chat.fallback": "Grazie per il tuo messaggio. Al momento posso rispondere solo alle domande più frequenti. Contattaci direttamente per maggiori informazioni.",

  "front.faq.chat.answer.hours": "Siamo aperti tutti i giorni dalle 10:00 alle 22:00.",
  "front.faq.chat.answer.reservation": "Sì, puoi prenotare un tavolo direttamente sul nostro sito web o telefonicamente.",
  "front.faq.chat.answer.groupReservation": "Per prenotazioni di gruppo, contattaci direttamente così possiamo trovare l’opzione migliore per te.",
  "front.faq.chat.answer.address": "Il nostro indirizzo è: Musterstraße 1, Berlino.",
  "front.faq.chat.answer.parking": "Sì, nelle vicinanze sono disponibili parcheggi.",
  "front.faq.chat.answer.phone": "Puoi contattarci al numero +49 000 000000.",
  "front.faq.chat.answer.payment": "Sì, da noi puoi pagare in contanti o con carta.",
  "front.faq.chat.answer.menu": "Puoi trovare il nostro menu aggiornato sul sito web. Se hai domande su piatti specifici, saremo felici di aiutarti.",
  "front.faq.chat.answer.vegetarian": "Sì, offriamo piatti vegetariani.",
  "front.faq.chat.answer.vegan": "Sì, nel nostro menu abbiamo anche opzioni vegane.",
  "front.faq.chat.answer.allergens": "Se hai allergie o intolleranze, contattaci direttamente. Saremo felici di fornirti informazioni sugli ingredienti.",
  "front.faq.chat.answer.takeaway": "Sì, il cibo può essere ordinato anche da asporto.",
  "front.faq.chat.answer.delivery": "Al momento, tramite il sito supportiamo solo prenotazioni e domande.",
  "front.faq.chat.answer.terrace": "Sì, con il bel tempo puoi sederti anche sulla nostra terrazza.",
  "front.faq.chat.answer.pets": "Contattaci direttamente se desideri venire con un animale domestico.",
  "front.faq.chat.answer.children": "Sì, le famiglie con bambini sono le benvenute.",
  "front.faq.chat.answer.wifi": "Sì, il Wi-Fi è disponibile per i nostri ospiti.",

  "front.acquaintance.callback.placeholder": "Il tuo numero di telefono",
  "front.acquaintance.callback.send": "Invia",
  "front.acquaintance.callback.sending": "Invio...",
  "front.acquaintance.callback.invalidPhone": "Inserisci un numero di telefono valido.",
  "front.acquaintance.callback.success": "Richiesta inviata. Ti contatterò presto.",
  "front.acquaintance.callback.error": "Errore durante l’invio della richiesta. Riprova.",

  "front.landingSeo.links.digitalMenu": "Menu digitale per ristoranti",
  "front.landingSeo.links.qrMenu": "Menu con codice QR per ristoranti",
  "front.landingSeo.links.multilingualMenu": "Menu multilingue per ristoranti",
  "front.landingSeo.links.reservation": "Prenotazione tavoli online per ristoranti",
  "front.landingSeo.links.freeDigitalMenu": "Prova gratis un menu digitale",
  "front.landingSeo.links.changeMenuOnline": "Modifica il menu online",
  
  "menu.title": "Menu",
  "menu.promo": "Offerte speciali",
  "menu.empty.categoryTitle": "Inserisci il nome della categoria",
  "menu.empty.itemTitle": "Inserisci il nome del prodotto",
  "menu.empty.itemDescription": "Inserisci la descrizione del prodotto",
  "cart.add": "Aggiungi al carrello",
  "cart.cancel": "Annulla",
  "section.video": "Presentazione video",
  "section.tables": "PRENOTAZIONE TAVOLO ONLINE",
  "section.table": "SCEGLI UN TAVOLO",
  "section.menu": "Menu del ristorante",
  "section.faq": "FAQ",
  "section.contact": "Contatto",
  "promo.buy": "Acquista",

  "front.tenant.resolving": "Rilevamento del ristorante tramite sottodominio…",
  "front.tenant.notFound": "Nessun cliente trovato per questo sottodominio",
  "front.tenant.resolveError": "Impossibile identificare il cliente",
  "front.menu.loading": "Caricamento…",
  "front.menu.loadError": "Impossibile caricare il menu",
  "front.menu.addtocart": "Carrello",
  "front.menu.cancel": "Annulla",
  "front.Number.servings": "Numero di porzioni",

  "orbit.menu": "MENU",
  "orbit.shef": "PRENOTAZIONE",
  "orbit.video": "VIDEO",
  "orbit.faq": "DOMANDE",
  "orbit.interior": "INTERNO",
  "orbit.footer": "SOCIAL MEDIA",

  "shef.title.line1": "ONLINE",
  "shef.title.line2": "PRENOTAZIONE",
  "shef.banner.label": "Scegli",
  "shef.banner.main": "il tuo tavolo",
  "shef.reserved": "PRENOTATO",

  "video.title": "ECCO COME CUCINIAMO — CON ONESTÀ E GUSTO",
  "video.add": "Aggiungi video",
  "add.video.but": "Aggiungi",

  "interior.title": "IL NOSTRO INTERNO",

  "footer.kontact": "CONTATTI",

  "telegram.title": "Per configurare le notifiche degli ordini su Telegram, devi:",
  "telegram.title.first": "1. Ottenere il BOT_TOKEN",
  "telegram.text.first": "Per ottenere un BOT_TOKEN, cerca e avvia il bot @BotFather su Telegram, invia il comando /newbot, segui le istruzioni per creare un nome e uno username unici per il bot, quindi copia il token API che @BotFather invia in risposta.",
  "telegram.title.two": "2. Ottenere il CHAT_ID",
  "telegram.text.two": "Per ottenere il CHAT_ID, cerca e avvia il bot @UserInfoBot su Telegram, invia il comando /start e poi copia l’ID ricevuto nel messaggio di risposta.",

  "cart.title": "IL TUO CARRELLO",
  "cart.header.aria": "Il tuo carrello",
  "cart.toggle.expand": "Espandi carrello",
  "cart.toggle.collapse": "Comprimi carrello",
  "cart.total.label": "Totale",
  "cart.total.products": "prodotti",
  "cart.button.primary": "ordina",
  "cart.button.back": "indietro",
  "cart.button.waiter": "CAMERIERE",

  "cart.mode.takeaway": "da asporto",
  "cart.mode.tableTime": "Ora e tavolo",
  "cart.mode.tableTime.disabled": "nessun tavolo libero",
  "cart.mode.tableTime.tooltip": "Ora e tavolo",
  "cart.mode.tableTime.tooltipNoFree": "nessun tavolo libero",
  "cart.mode.inHouse": "sul posto",

  "cart.bookingFlow.title": "PRENOTAZIONE. NUMERO DEL TAVOLO",
  "cart.deposit.itemTitle": "Prenotazione tavolo (deposito)",
  "cart.deposit.lineTitle": "Deposito",
  "cart.deposit.badge": "Deposito {amount}€",

  "cart.table.msg.tempChosen": "Tavolo {table} selezionato temporaneamente ✓",
  "cart.table.msg.noFree": "Purtroppo non ci sono tavoli liberi",
  "cart.table.msg.chooseOrDefault": "Scegli un tavolo oppure usa la selezione predefinita.",

  "cart.table.select.reserved": "PRENOTATO",
  "cart.table.select.pick": "SCEGLI",
  "cart.table.select.any": "QUALSIASI",

  "cart.inHouse.title": "SCEGLI IL NUMERO DEL TUO TAVOLO",
  "cart.inHouse.select.placeholder": "Scegli tavolo",
  "cart.inHouse.select.option": "Tavolo #{n}",

  "cart.checkout.back": "Indietro",
  "cart.payment.preparing": "Preparazione del pagamento…",
  "cart.loading": "Caricamento…",

  "mockCheckout.title.paymentMethod": "METODO DI PAGAMENTO",
  "mockCheckout.method.card": "Carta bancaria",
  "mockCheckout.method.paypal": "PayPal",
  "mockCheckout.method.gpay": "Google Pay",
  "mockCheckout.cardForm.title": "INSERISCI I DATI DELLA CARTA",
  "mockCheckout.cardForm.numberLabel": "NUMERO DELLA CARTA",

  "mockCheckout.error.invalidCardNumber": "Numero della carta non valido",
  "mockCheckout.error.enter16Digits": "Inserisci 16 cifre",
  "mockCheckout.error.expiryFormat": "Formato MM/AA",
  "mockCheckout.error.expiryMonthRange": "Mese 01–12",
  "mockCheckout.error.cardExpired": "Carta scaduta",
  "mockCheckout.error.cvc3Digits": "3 cifre",

  "mockCheckout.error.sendTelegram": "Errore durante l’invio a Telegram",
  "mockCheckout.error.generic": "Qualcosa è andato storto",

  "mockCheckout.reserve.clientNotFound": "Cliente non trovato",
  "mockCheckout.reserve.tablesNotFound": "Questo cliente non ha una sezione tavoli",
  "mockCheckout.reserve.tableNotFound": "Tavolo non trovato",
  "mockCheckout.reserve.alreadyReserved": "Questo tavolo è appena stato occupato. Scegline un altro.",
  "mockCheckout.reserve.noFreeTables": "Al momento non ci sono tavoli liberi",
  "mockCheckout.reserve.tableNotSelected": "Scegli un tavolo",
  "mockCheckout.reserve.genericError": "Errore di prenotazione",

  "mockCheckout.button.back": "indietro",
  "mockCheckout.button.pay": "PAGA",
  "mockCheckout.button.sending": "…invio",
  "mockCheckout.button.paid": "...",
  "mockCheckout.button.payInvalidTitle": "Controlla i dati della carta",

  "admin.booking.lead.title": "TEMPO MINIMO DI PRENOTAZIONE",
  "admin.booking.lead.note": "Questo vale solo per le prenotazioni degli ospiti in modalità “tavolo e ora”. L’intervallo è di 30 minuti.",

  "dateTimeStep.select.time": "SELEZIONA ORA",

  "admin.title": "PANNELLO ADMIN",
  "admin.loading": "Caricamento…",
  "admin.nav.delete": "Elimina",
  "admin.nav.back": "Indietro",
  "admin.nav.next": "AVANTI",
  "admin.nav.confirm": "SALVA",
  "admin.nav.confirm.now": "salvataggio ...",
  "admin.booking.settings": "Impostazioni prenotazione",
  "admin.booking.deposit": "IMPORTO DEL DEPOSITO",
  "admin.booking.deposit.note": "Il deposito viene addebitato quando l’ospite prenota solo un tavolo",

  "admin.hub.editmenu": "MODIFICA MENU",
  "admin.hub.qr": "CODICE QR",
  "admin.hub.prices": "IL TUO PIANO",
  "admin.hub.settings": "IMPOSTAZIONI",

  "admin.panel.editmenu": "Modifica menu",
  "admin.validation.required": "Campo obbligatorio",
  "admin.panel.add": "Aggiungi posizione",
  "admin.panel.menu": "Modifica elenco menu",
  "admin.panel.telegram": "Telegram",
  "admin.panel.table": "GESTIONE TAVOLI",
  "admin.set.table": "Sale / tavoli",
  "admin.set.logo": "Logo e sfondi",
  "admin.logo.successfully.applied": "Logo applicato con successo",
  "admin.logo.download.error": "Errore di download",
  "admin.settings.number.rooms": "Numero di sale",
  "admin.settings.room": "Sala",

  "admin.qr.title": "Codice QR per gli ospiti",
  "admin.qr.alt": "QR per ristorante",
  "admin.qr.copy": "copia link",
  "admin.qr.copied": "✓ copiato",
  "admin.qr.note": "Gli ospiti possono scansionare questo codice per aprire subito la tua pagina.",

  "admin.link.notfound": "Link non trovato",
  "admin.table.info": "La gestione dei tavoli è disponibile in questa pagina. Lo stato cambia premendo sul tavolo.",
  "admin.prices.temp": "I prezzi sono temporaneamente non disponibili.",
  "admin.forgot.password": "Hai dimenticato la password?",
  "admin.success.description": "Clicca OK e aggiungi un altro prodotto",

  "order.success": "Articolo aggiunto al carrello!",
  "order.error": "Questo articolo è già nel carrello",

  "popap.product.removal": "Rimozione prodotto",
  "popap.category.removal": "Rimozione categoria",
  "popap.want.delete.product": "Sei sicuro di voler eliminare il prodotto",
  "popap.want.delete.category": "Sei sicuro di voler eliminare la categoria?",

  "admin.settings.guestLang": "Lingua predefinita per gli ospiti",
  "admin.settings.adminLang": "Lingua predefinita per admin",
  "admin.settings.noteGuest": "Questa lingua sarà impostata come predefinita quando gli ospiti aprono la pagina.",
  "admin.settings.noteAdmin": "Questa lingua sarà impostata come predefinita nel pannello admin.",
  "admin.language": "Lingua",
  "admin.settings.logo": "Logo del locale",
  "admin.settings.logo.text": "Carica il tuo logo (PNG/JPG/WEBP/SVG, fino a 2 MB). Poi clicca “Salva”; il logo attuale verrà sostituito con quello nuovo.",
  "admin.settings.backtable": "Immagine di sfondo nella schermata di selezione dei tavoli",
  "admin.settings.backhome": "Immagine di sfondo della schermata iniziale",
  "admin.settings.backtable.text": "Carica un’immagine di sfondo (SVG/PNG/JPG/WEBP). Poi clicca “Salva”; lo sfondo attuale verrà sostituito con quello nuovo.",
  "admin.settings.language.visitors": "Lingua principale per i visitatori del locale",
  "admin.settings.language.visitors.text": "Questa lingua sarà impostata come lingua principale quando gli ospiti aprono la pagina",
  "admin.settings.language.admin": "Lingua principale del tuo pannello admin",
  "admin.settings.language.admin.text": "Questa lingua sarà impostata come predefinita all’apertura del pannello admin",
  "admin.settings.gallery": "Galleria",
  "admin.settings.social": "Social network",
  "admin.settings.number.tables": "Numero di tavoli",
  "admin.settings.how.many.tables": "Quanti tavoli ci sono nel locale?",
  "admin.settings.tables.test": "Salva il numero di tavoli e torna alla scheda precedente per configurare ogni tavolo separatamente.",
  "admin.settings.upload.panoramic": "Carica una foto panoramica della sala del tuo locale",
  "admin.settings.table": "Tavolo",
  "admin.settings.table.not.found": "Tavolo non trovato",
  "admin.settings.contact.details": "Dati di contatto",
  "admin.contacts.company": "Nome azienda",
  "admin.contacts.address": "Indirizzo",
  "admin.contacts.phone": "Numero di telefono",
  "admin.socials.title": "Social media",
  "admin.settings.rooms.hint": "Indica il numero di sale del locale",

  "admin.settable.title": "Passo 3. Numerazione dei tavoli",
  "admin.settable.text1": "Ogni etichetta ha un numero; posiziona le etichette secondo i numeri dei tavoli.",
  "admin.settable.text2": "Usa l’interruttore per modificare la dimensione dell’etichetta.",
  "admin.settable.text3": "Salva i dati del tavolo corrente e clicca sull’icona corrispondente per passare da un tavolo all’altro.",
  "admin.setqr.title": "I tuoi codici QR",
  "admin.setqr.text1": "in questa pagina vengono salvati i tuoi messaggi, menu e codici QR",
  "admin.setqr.text2": "con l’acquisto del piano BASIC verranno generati automaticamente un codice QR e un link al tuo sottodominio (ad esempio example.best-place.club)",
  "admin.setqr.text3": "puoi aprire il link, copiarlo e salvare il codice QR come immagine sul tuo dispositivo",
  "admin.setpanorama.title": "Passo 2. Foto panoramica",
  "admin.setpanorama.text1": "Aggiungi una foto panoramica. Si consiglia di usare file leggeri, ad esempio in formato WEBP.",
  "admin.setpanorama.text2": "Se l’immagine è stata caricata correttamente, la vedrai nell’anteprima qui sotto.",
  "admin.setnumber.title": "Passo 1. Numero di tavoli",
  "admin.setnumber.text1": "Scegli il numero di tavoli nel tuo locale",
  "admin.setnumber.text2": "Si consiglia di iniziare la configurazione con uno o due tavoli e poi aumentare il numero.",

  "admin.current.logo": "Logo attuale",
  "admin.add.photo": "qui puoi aggiungere un file",
  "admin.add.file": "formati file per il caricamento: .xlsx, .xls, .csv",
  "admin.add.file.but": "Aggiungi file",
  "admin.import.format": "Formato colonne: Categoria / Titolo / Descrizione / Prezzo",
  "admin.import.follow": "segui il formato colonne indicato e prepara un file nel formato corrispondente",
  "admin.import.BeСareful": "Attenzione: durante l’importazione i dati precedenti verranno persi",
  "admin.add.photo.but": "Aggiungi foto",
  "admin.add.photo.set": "Aggiungi foto",

  "admin.wizard.step1": "Scegli categoria",
  "admin.wizard.step2": "Nome e prezzo",
  "admin.wizard.step3": "Descrizione e foto",
  "admin.wizard.ready": "Pronto",
  "admin.wizard.defaultTitle": "Aggiungi prodotto",
  "admin.wizard.step1.desc": "Passo 1. Scegli una categoria esistente oppure creane una nuova",
  "admin.wizard.step2.desc": "Passo 2. Scegli il nome del prodotto e imposta il prezzo",
  "admin.wizard.step3.desc": "Passo 3. Scrivi una descrizione del prodotto, aggiungi una foto e clicca su salva",
  "admin.wizard.step1.desc.short": "Passo 1. Scegli una categoria esistente o nuova",
  "admin.wizard.step2.desc.short": "Passo 2. Aggiungi nome e prezzo del prodotto",
  "admin.wizard.step3.desc.short": "Passo 3. Descrivi il prodotto e aggiungi una foto",

  "admin.wizard.tab.existing": "Esistente",
  "admin.wizard.tab.new": "Nuova",
  "admin.wizard.cat.loading": "Caricamento…",
  "admin.wizard.cat.empty": "Non ci sono ancora categorie. Passa a “Nuova” e crea la prima.",

  "admin.form.categoryKeyDe": "Categoria (KEY/IT)",
  "admin.form.categoryEn": "Categoria (EN)",
  "admin.form.titleMain": "Nome prodotto",
  "admin.form.descMain": "Descrizione del prodotto",
  "admin.validation.req": "Inserisci il nome del prodotto",
  "admin.form.titleDe": "Titolo (DE)",
  "admin.form.titleEn": "Titolo (EN)",
  "admin.form.nameDe": "Nome (DE)",
  "admin.form.nameEn": "Nome (EN)",
  "admin.form.price": "Prezzo",
  "admin.form.descDe": "Descrizione (DE)",
  "admin.form.descEn": "Descrizione (EN)",

  "admin.toast.productAdded": "Prodotto aggiunto con successo",
  "admin.tooltip.fixFormErrors": "Correggi gli errori nel modulo",

  "admin.validation.firstCharNotDigit": "Il primo carattere non può essere una cifra.",
  "admin.validation.maxChars": "accorcia il nome del prodotto",
  "admin.validation.chooseCategory": "Scegli una categoria.",
  "admin.validation.chooseCategoryFromList": "Scegli una categoria dall’elenco.",
  "admin.validation.enterCategoryName": "Inserisci il nome della categoria.",
  "admin.validation.enterProductName": "Inserisci il nome del prodotto.",
  "admin.validation.priceFormat": "Formato prezzo non valido (es. 12.50)",
  "admin.validation.enterDescription": "Inserisci una descrizione.",
  "admin.tarif.apply": "applica",
  "admin.menu.creating": "Crea menu",
  "admin.choose.template": "Passo 1: Scegli un modello",
  "admin.choose.template2": "Passo 2: Controlla le righe dei prodotti",
  "admin.choose.atyle": "Scegli uno stile per il menu. Potrai modificarlo in seguito",

  "admin.error.tenantNotFound": "Nessun cliente trovato per questo sottodominio.",
  "admin.error.resolveClient": "Impossibile identificare il cliente.",
  "admin.error.menuLoad": "Impossibile caricare il menu.",
  "admin.error.saveLang": "Impossibile salvare la lingua.",
  "admin.error.clientNotFound": "Cliente non trovato sul server",
  "admin.error.arrNotFound": "Array di dati non trovato per questo cliente",

  "tpl.premium.title": "Premium",
  "tpl.classic.title": "Classico",
  "tpl.dark.title": "Scuro",
  "tpl.minimal.title": "Minimalista",
  "tpl.premium.desc": "Più venduto",
  "tpl.classic.desc": "chiaro",
  "tpl.dark.desc": "scuro",
  "tpl.minimal.desc": "minimalista",

  "tp2.position.total": "Ora hai:",
  "tp2.position.punkte": "Voci di menu",
  "tp2.position.template": "Modello",

  "tp3.qr.link": "Codice QR e link al menu",
  "tp3.step3.title": "Passo 3: Anteprima / Pubblicazione",
  "admin.tp.progres.publication": "Pubblicazione",
  "admin.tp.progres.positionen": "Posizione",

  "tp4.link.copy": "COPIA",
  "tp4.link.copy.ok": "✓ COPIATO",

  "admin.tp.publish": "Pubblica",
  "admin.tp.posting": "pubblicazione ...",

  "admin.import.from.excel": "Importa menu da Excel",

  "popap.successful.payment": "Pagamento riuscito",

  "landing.title": "Soluzioni digitali per ristoranti",
  "landing.title.login": "Login",
  "landing.text": "Lancia il sito del tuo ristorante in pochi minuti!",
  "landing.try.now": "prova gratis",
  "landing.title.to": "Per chi è adatto il nostro servizio?",
  "landing.title.answer": "Prima di tutto, sarà utile ai proprietari di locali il cui obiettivo è attirare nuovi clienti e fidelizzare quelli esistenti",
  "landing.content.title.first": "Menu online con codice QR",
  "landing.content.first": "I tuoi visitatori possono contare su un menu e prezzi aggiornati semplicemente scansionando il codice QR. Le offerte speciali aumenteranno la fedeltà dei visitatori al tuo prodotto",
  "landing.content.title.second": "Prenotazioni tavolo online",
  "landing.content.second": "Offriamo agli ospiti una prenotazione visuale del tavolo online con foto panoramiche aggiuntive. Se necessario, possono passare tra zone vicine",
  "landing.content.title.third": "Contenuti d’atmosfera",
  "landing.content.third": "I potenziali ospiti possono visualizzare diversi contenuti: foto degli interni, video della preparazione dei piatti migliori e una vista panoramica della sala.",
  "landing.content.title.four": "Aumenta lo scontrino medio",
  "landing.content.four": "Offri ai tuoi ospiti eventi come banchetti, compleanni o offerte speciali per ordini più grandi o quotidiani",
  "landing.request": "Ti contatteremo a breve",
  "callback.invalidPhone": "Inserisci un numero di telefono valido",
  "landing.enter.number": "IL TUO NUMERO",
  "callback.submitError": "Il numero non può essere inviato. Riprova",
  "landing.tariff.advance": "Avviso",
  "landing.tariff.advance.desc": "All’interno del piano scelto puoi riempire gratuitamente la tua applicazione con contenuti",
  "landing.tariff.one-time-not-included": "Calcolo del prezzo individuale. Nell’angolo destro dello schermo c’è un pulsante di contatto. Lascia il tuo numero e ti contatteremo",
  "landing.tariff.one-time-services": "Servizi una tantum",
  "landing.tariff.logo-creation": "Creazione logo",
  "landing.tariff.selling-images": "Vendita di immagini prodotto",
  "landing.tariff.panorama-creation": "Creazione panorama",

  "demo.video.unsupported": "Il tuo browser non supporta il video",
  "demo.title.after": "panoramica del servizio",
  "demo.title.accent": "breve",
  "demo.title.before": "Una",
  "demo.title.total": "sul servizio",
  "demo.title": "Panoramica video",

  "landing.free.first": "Menu online tramite codice QR disponibile, risultato in pochi minuti.",
  "landing.free.second": "Possibilità di modificare il menu per la data corrente",
  "landing.free.third": "Accesso al designer del menu",
  "landing.basic.first": "Una pagina URL completa con accesso al menu tramite codice QR",
  "landing.basic.second": "Ordini online per i vostri visitatori",
  "landing.basic.third": "Prenotazioni tavolo online, foto panoramiche della sala, tavoli cliccabili e visualizzazione in tempo reale dei tavoli prenotati e disponibili",
  "landing.basic.fourth": "Menù con traduzione in qualsiasi lingua",
  "landing.pro.first": "Funzionalità che permette di gestire offerte di prezzo, creare banner e strategie di marketing",
  "landing.pro.second": "Possibilità di gestire il sistema di fidelizzazione degli ospiti e influenzare il risultato finale delle recensioni Google",
  "landing.pro.third": "",
  "landing.title.free": "Gratis per 14 giorni",
  "landing.registerTitle": "Registrazione",
  "landing.tariff.selection": "Scelta del piano",
  "landing.tariff.subdomain": "Registrazione sottodominio",
  "landing.tariff": " / al mese",
  "landing.your.tariff": "il tuo piano",
  "landing.your.example": "ad esempio",
  "landing.Subdomain.selection": "Scelta sottodominio",
  "landing.password": "password",
  "landing.tariff.free": "GRATIS",
  "landing.tariff.free-description": "per conoscere il servizio",
  "landing.tariff.basic": "BASIC",
  "landing.tariff.basic-description": "funzioni base per iniziare",
  "landing.tariff.pro": "PRO",
  "landing.tariff.pro-description": "Per utenti avanzati",
  "landing.tariff.selected": "✓ selezionato",
  "landing.legal.text.start": "Accetto i",
  "footer.legal.terms": "Termini",
  "landing.legal.text.mid": "e",
  "landing.tariff.optional": "Servizi una tantum",
  "landing.tariff.one-time-note": "Visualizza le tariffe per creare immagini di alta qualità e orientate alla vendita",
  "landing.tariff.pro-locked-desc": "Questo piano non è ancora disponibile",
  "landing.tariff.in-development": "In sviluppo",
  "landing.tariff.free-one-time-desc": "per riempire la tua pubblicazione con immagini di alta qualità",

  "footer.legal.privacy": "Privacy",
  "footer.legal.privacy.and": "policy",
  "footer.about": "Piattaforma per ristoranti: menu, prenotazioni tavoli, ordini e pannello admin.",

  "server.common.unknown": "Errore sconosciuto.",
  "server.common.serverError": "Errore interno del server.",
  "server.common.networkError": "Errore di rete. Riprova.",
  "server.common.clientIdMissing": "Errore: clientId mancante.",

  "server.login.required": "Email e password sono obbligatorie.",
  "server.login.invalidCredentials": "Email o password non validi.",
  "server.login.signupIncomplete": "L’account non è ancora attivo. Completa la registrazione.",
  "server.login.success": "Accesso riuscito!",

  "server.register.required": "Email e password sono obbligatorie.",
  "server.register.emailExistsActive": "Esiste già un utente con questa email. Usa il login.",
  "server.register.resume": "Registrazione in corso.",
  "server.register.success": "Registrazione riuscita!",

  "server.signupComplete.success": "Attivazione riuscita!",
  "server.signupComplete.error": "Attivazione non riuscita.",

  "server.subdomain.required": "clientId e sottodominio sono obbligatori.",
  "server.subdomain.planInvalid": "Piano non valido. Consentiti: free | basic | pro.",
  "server.subdomain.invalid": "Sottodominio non valido (a-z, 0-9, '-', 3–30, senza '-' all’inizio/fine).",
  "server.subdomain.reserved": "Questo sottodominio è riservato.",
  "server.subdomain.taken": "Questo sottodominio è già occupato.",
  "server.subdomain.userNotFound": "Utente non trovato.",
  "server.subdomain.success": "Sottodominio registrato. Reindirizzamento…",
  "server.subdomain.error": "Registrazione del sottodominio non riuscita.",

  "landing.loginTitle": "Login",
  "landing.btn.login": "Login",
  "landing.btn.register": "Registrazione",
  "landing.btn.enter": "Entra",
  "landing.loggingIn": "Accesso…",
  "landing.registering": "Registrazione…",
  "landing.activating": "Attivazione…",
  "landing.subdomain.registering": "Registrazione sottodominio…",
  "landing.redirecting": "Reindirizzamento…",
  "landing.legal.required": "Accetta i termini e la privacy policy.",

  "landing.subdomain.err.empty": "Inserisci un sottodominio.",
  "landing.subdomain.err.chars": "Solo lettere, numeri e '-', 3–30 caratteri.",
  "landing.subdomain.err.hyphen": "Il sottodominio non può iniziare o finire con '-'.",
  "landing.subdomain.err.reserved": "Questo sottodominio è riservato.",

  "admin.menuLanguages.title": "Lingue del menu",
    "admin.menuLanguages.default": "La lingua che un visitatore del tuo locale vedrà per prima (per impostazione predefinita)",
    "admin.menuLanguages.hint": "Seleziona le lingue che verranno utilizzate in aggiunta",
    "common.success": "Riuscito",
    "admin.import.activeLangs": "Lingue del menu attive",
  "admin.import.sourceLangHint": "Il file Excel verrà scritto solo nella lingua selezionata. Gli altri campi relativi alle lingue attive rimarranno vuoti",
  "admin.import.sourceLang": "Specificare la lingua in cui è scritto il file Excel",
  "admin.import.mainLang": "il principale",
  "booking.date.today": "Oggi",
  "booking.date.tomorrow": "Domani",
  "booking.room": "Sala",

  "front.faq.chat.answer.greeting": "Ciao! Posso aiutarti con prenotazioni, menu, indirizzo, orari di apertura e altre domande.",
"front.faq.chat.answer.howAreYou": "Grazie, sto bene! Come posso aiutarti riguardo al ristorante?",
"front.faq.chat.answer.thanks": "Prego! Scrivici pure se hai altre domande.",
"front.faq.chat.answer.goodbye": "Arrivederci! Saremo felici di accoglierti.",
"front.faq.chat.answer.whoAreYou": "Sono l’assistente digitale del ristorante. Aiuto gli ospiti con le domande più frequenti.",
"front.faq.chat.answer.help": "Posso aiutarti con prenotazioni, menu, indirizzo, numero di telefono, pagamenti, allergeni, consegna e altre domande.",
"front.faq.chat.answer.recommendation": "Ti consiglio di guardare il menu — lì trovi i piatti attuali e puoi scegliere ciò che fa per te.",
"front.faq.chat.answer.compliment": "Grazie mille! Ci fa molto piacere.",

"checkout.button.send": "INVIA",
"checkout.button.sending": "Invio in corso ...",
"checkout.button.sent": "Inviato",
"checkout.title.order": "ORDINE",
"checkout.phone.title": "Inserisci il tuo numero di telefono",
"checkout.phone.label": "Numero di telefono",

"footer.workingHours": "Orario di lavoro",

"admin.offline.title": "Nessuna connessione Internet",
"admin.offline.text": "Verifica la connessione Internet. Potrai continuare a lavorare automaticamente non appena la connessione sarà ripristinata.",
"admin.offline.status": "In attesa della connessione…",

};

export default it;